import { render, staticRenderFns } from "./PowerupSearchEditComponent.vue?vue&type=template&id=953d8f1a&scoped=true"
import script from "./PowerupSearchEditComponent.vue?vue&type=script&lang=ts"
export * from "./PowerupSearchEditComponent.vue?vue&type=script&lang=ts"
import style0 from "./PowerupSearchEditComponent.vue?vue&type=style&index=0&id=953d8f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953d8f1a",
  null
  
)

export default component.exports